<template>
    <v-container grid-list-md>
      <v-layout row wrap align-center justify-center fill-height>
        <v-flex xs12 sm8 lg4 md5>
          <v-card class="login-card">
            <v-card-title>
              <span class="headline">General Valor : Connexion</span>
            </v-card-title>

            <v-spacer/>

            <v-card-text>

              <v-layout
                row
                fill-height
                justify-center
                align-center
                v-if="loading"
              >
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                />
              </v-layout>


              <v-form v-else ref="form" v-model="valid" lazy-validation>
                <v-container>

                  <v-text-field
                    v-model="credentials.username"
                    :counter="70"
                    label="identifiant"
                    :rules="rules.email"
                    maxlength="70"
                    required
                  />

                  <v-text-field
                    type="password"
                    v-model="credentials.password"
                    :counter="20"
                    label="mot de passe"
                    :rules="rules.password"
                    maxlength="20"
                    required
                  />

                </v-container>
                <v-btn class="pink white--text" :disabled="!valid" @click="login">Login</v-btn>

              </v-form>


            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>

import axios from 'axios';
import swal from 'sweetalert2';
import router from '../../plugins/router';
import config from "../../config.json";

export default {
    name: 'Auth',
    data: () => ({
        credentials: {},
        valid:true,
        loading:false,
        rules :{
          username: [
            v => !!v || "identifiant nécessaire"
          ],
          password: [
            v => !!v || "mot de passe nécessaire"
          ]
        }
    }),
    methods: {
        login() {
             // checking if the input is valid
            if (this.$refs.form.validate()) {
              this.loading = true;
              axios.post(config.api.baseurl+'/auth', this.credentials).then(res => {
                this.$session.start();
                this.$session.set('token', res.data.token);
                
                axios({
                  method : 'get',
                  url : config.api.baseurl+'/api/user',
                  headers: {'Authorization': 'JWT ' + this.$session.get('token')},
                })
                .then(response => {
                  this.$session.set('user',response.data);
                  router.push('/');
                })
                .catch(e => {
                  console.error(e);
                });
                
              }).catch((e) => {
                this.loading = false;
                console.error(e);
                swal({
                  type: 'warning',
                  title: 'Error',
                  text: 'Identifiant ou mot de passe incorrect',
                  showConfirmButton:false,
                  showCloseButton:false,
                  timer:3000
                })
              })
            }
        }
    }
}
</script>